export default __webpack_public_path__ + "static/media/work-active.68a61a04.svg";